import { ChangeDetectionStrategy, Component, input, inject } from '@angular/core';
import { MonthService } from '../../services/month.service';
import { NavigationService } from '../../services/navigation.service';
import { AnalyticsService } from '../../services/analytics.service';
import {
  EVENT_PREVIOUS_MONTH_SELECTED,
  EVENT_TODAYS_MONTH_SELECTED,
  EVENT_NEXT_MONTH_SELECTED,
} from '../../analytics/events';
import { SessionService } from '../../services/session.service';
import { map, filter } from 'rxjs/operators';
import { UiButtonDirective } from '../../ui/button/button.directive';
import { UiIconComponent } from '../../ui/icon/icon.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-month-selector',
  templateUrl: './month-selector.component.html',
  host: {
    class: 'inline-flex w-month-selector items-center gap-0',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiButtonDirective, UiIconComponent, AsyncPipe],
})
export class MonthSelectorComponent {
  private readonly analytics = inject(AnalyticsService);
  private readonly nav = inject(NavigationService);
  readonly month = inject(MonthService);
  private readonly session = inject(SessionService);

  readonly currentMonthYear = input.required<string>();

  readonly startMonthYear$ = this.session.session$.pipe(
    filter(session => !!session),
    map(session => session.account.startMonthYear),
  );

  previousMonth() {
    const previousMonthYear = this.month.findMonthYear(this.currentMonthYear(), -1);
    void this.nav.navigateToMonthYear(previousMonthYear);
    this.analytics.sendEvent(EVENT_PREVIOUS_MONTH_SELECTED);
  }

  todaysMonth() {
    const todaysMonthYear = this.month.monthYearFromDate();
    void this.nav.navigateToMonthYear(todaysMonthYear);
    this.analytics.sendEvent(EVENT_TODAYS_MONTH_SELECTED);
  }

  nextMonth() {
    const nextMonthYear = this.month.findMonthYear(this.currentMonthYear(), 1);
    void this.nav.navigateToMonthYear(nextMonthYear);
    this.analytics.sendEvent(EVENT_NEXT_MONTH_SELECTED);
  }
}
